import { PageViewAnalytics } from '~/components/PageViewAnalytics'
import GridList from '~/components/UI/GridList'
import GridListNav from '~/components/UI/GridListNav'
import HeroGridList from '~/components/UI/HeroGridList'

import { getPressListStaticPropsFunction } from '~/data/press-list-page-data'
import { PressListPageData } from '~/data/press-list-page-data/serializer'

import css from './styles.module.scss'

function PressListPage({ hero, grid }: PressListPageData) {
  return (
    <section className={css.PressListPage}>
      <div className={css.content}>
        {hero && <HeroGridList {...hero} />}
        {grid && <GridList hasReadMore hasPagination {...grid} />}
      </div>
      {hero?.links && (
        <GridListNav className={css.stickyNav} links={hero?.links} />
      )}
      <PageViewAnalytics template={'page'} />
    </section>
  )
}

export default PressListPage

export const getStaticProps = getPressListStaticPropsFunction()
